import {
	Button,
	Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	LoginContext,
	LoginContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";

export const LoginButton = () => {
	const { onChangeStep, onChangeLogin } = useContext(
		MultistepContext
	) as MultistepContextValues;
	const { isLogged, onLogout } = useContext(LoginContext) as LoginContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const loginStep = findComponentStep(selectedFlow!, "Login");

	return (
		<>
			<Typography
				color="primary"
				sx={{ fontWeigth: 500, fontFamily: "Noto Sans Gujarati", fontSize: 16 }}
			>
				<FormattedMessage
					id="register.logInMessage"
					defaultMessage="¿Ya tienes una cuenta?"
				/>
			</Typography>
			<Button
				variant="text"
				onClick={() => {
					if (isLogged) onLogout(onChangeLogin);
					onChangeStep(loginStep);
				}}
			>
				<FormattedMessage id="register.logIn" defaultMessage="Iniciar sesión" />
			</Button>
		</>
	);
};